/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

import {
	type AssociationEdge,
	type AssociationEdgeEntity,
	type ExternalConversation,
} from '@atlassian/search-client';

/**
 * The whitespace in between aliases <!here> <!channel> is removed
 * This constant prevent the alias from being pushed together ex: "@here@channel"
 * We are using this constant rather than adding a space through CSS because it adds
 * a real space character that does not break up the text when selecting.
 * */
const SPACE = ' ';

interface ChannelProps {
	children?: string[];
	associations?: AssociationEdge<AssociationEdgeEntity>[];
	noSpace?: boolean;
}

const channelStyle = css({
	whiteSpace: 'nowrap',
});

export const Channel = ({ children, associations, noSpace }: ChannelProps) => {
	const channelId = children?.[0];
	const channelAssociation = associations
		?.filter(
			(edge): edge is AssociationEdge<ExternalConversation> =>
				edge?.node?.entity?.__typename === 'ExternalConversation',
		)
		.find((edge) => Boolean(channelId) && channelId === edge.node.entity.channelId);

	if (!channelAssociation) {
		return null;
	}

	const entity = channelAssociation?.node?.entity;
	return (
		<span css={channelStyle}>
			{noSpace ? '' : SPACE}#{entity?.displayName || channelAssociation?.node?.title}
		</span>
	);
};
